import { render, staticRenderFns } from "./MyCollections.vue?vue&type=template&id=ff1fdd5e"
import script from "./MyCollections.vue?vue&type=script&lang=js"
export * from "./MyCollections.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports